import { TimeHelper } from "src/utils/time-helper";
import { RHFSelect } from "../hook-form";
import { useState } from "react";
import { useTheme } from '@mui/material/styles';


const TimeZoneSelect = ({ ...other }) => {
  const theme = useTheme();
  const timeZoneList = TimeHelper.GetTimeZoneList();
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const [selectedValue, setSelectedValue] = useState(localTimeZone);
  const { value: propValue, onChange, sx, ...selectProps } = other;
  const value = propValue ?? selectedValue;

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    onChange?.(event);
  };

  return (
    <RHFSelect
      name="timeZone"
      placeholder="TimeZone"
      label="TimeZone"
      {...selectProps}
      defaultValue={localTimeZone}
      value={value}
      onChange={handleChange}
      sx={{
        color: value === 'UTC' ? theme.palette.text.primary : 'black',
        ...sx,
      }}
    >
      <option value="UTC">
      UTC
      </option>
      <option value={localTimeZone}>
      {localTimeZone} : Current Local Timezone
      </option>
      {timeZoneList.map((option) => (
        <option key={option.timeZone} value={option.timeZone}>
          {option.timeZone}: UTC{option.offset}
        </option>
      ))}
    </RHFSelect>
  );
};

export default TimeZoneSelect;
